import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./ComoFunciona.css";

export default function ComoFunciona() {
  return (
    <Container>
      <Row id="como-funciona">
        <Col className="title-col">
          <h2 className="section-title">COMO FUNCIONA</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="como-funciona-text">
            Ao contratar e estar com o Plano Assistencial Grupo Krause em dia,
            <span> sua participação é automática.</span>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="como-funciona-text">
            Como ganhar um <span>código da sorte</span> para concorrer a prêmios
            mensalmente:
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="code-container">
            <h2 className="code-title">1 CÓDIGO</h2>
            <span className="code-box-wrap">
              <div className="code-box">
                <p className="code-text">
                  Contrate um <br />
                  Plano Assistencial <br />
                  Grupo Krause*
                </p>
                <span className="code-asterisk">
                  *Válido para novos associados
                </span>
              </div>
            </span>
          </div>
        </Col>
        <Col>
          <div className="code-container">
            <h2 className="code-title">1 CÓDIGO</h2>
            <span className="code-box-wrap">
              <div className="code-box">
                <p className="code-text">
                  Pague <br />a mensalidade <br />
                  sempre em dia
                </p>
              </div>
            </span>
          </div>
        </Col>
        <Col>
          <div className="code-container">
            <h2 className="code-title">1 CÓDIGO</h2>
            <span className="code-box-wrap">
              <div className="code-box">
                <p className="code-text">
                  Indique novos <br />
                  associados para <br />
                  aumentar suas chances*
                </p>
                <span className="code-asterisk">
                  *Válido para associados efetivados
                </span>
              </div>
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="primary-btn-col">
          <a
            href="https://centraldocliente.grupokrause.com.br/login?redirect=/boletos"
            rel="noopener noreferrer"
            target="_blank"
            className="primary-btn"
          >
            ACESSAR MEUS CÓDIGOS
          </a>
        </Col>
      </Row>
    </Container>
  );
}
